import { auth } from "@/auth/actions";
import { ActiveProgramBanner } from "@/components/active-program-banner";
import Header from "@/components/header";
import { Outlet, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_app")({
  component: RouteComponent,
  beforeLoad: async () => {
    try {
      const result = await auth();
      const subject = result.body;
      return {
        user: subject.authenticated ? subject.properties : null,
      };
    } catch (e) {
      console.error("[_app beforeLoad] auth() FAILED:", e);
      return { user: null };
    }
  },
});

function RouteComponent() {
  return (
    <>
      <Header />
      <ActiveProgramBanner />
      <Outlet />
    </>
  );
}
